import { render, staticRenderFns } from "./accountmanagementCreat.vue?vue&type=template&id=4d4a09cc&scoped=true&"
import script from "./accountmanagementCreat.vue?vue&type=script&lang=js&"
export * from "./accountmanagementCreat.vue?vue&type=script&lang=js&"
import style0 from "./accountmanagementCreat.vue?vue&type=style&index=0&id=4d4a09cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a09cc",
  null
  
)

export default component.exports